// Angular
import { ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

// Libraries
import { takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

// Auth
import { AppCleanup } from '../../../../shared/models';
import { ConfirmPasswordValidator } from '../../../../shared/validators/confirm-password.validator';
import { environment } from '../../../../../environments/environment';
import { PasswordChangeDto } from '../../models/password-change-dto.model';

// Services
import { CoreService } from '../../../../shared/services';
import { AuthService } from '../../services/auth.service';
import { SpinnerService } from '../../../../shared/components/spinner/services/spinner.service';

// Helpers
import { FormHelper } from '../../../../shared/helpers/form.helper';

// Enums
import { StatusType } from '../../../../shared/enums';

@Component({
	selector: 'change-password',
	templateUrl: './change-password.component.html',
	styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent extends AppCleanup implements OnInit, OnDestroy {
	@HostBinding('class') classes = 'component-container';
	form: FormGroup;
	errors: any = [];
	token: string;
	username: string;
	showPassword: boolean = false;
	showConfirmPassword: boolean = false;

	constructor(
		private authService: AuthService,
		private translateService: TranslateService,
		private router: Router,
		private formBuilder: FormBuilder,
		private route: ActivatedRoute,
		private coreService: CoreService,
		private spinnerService: SpinnerService
	) {
		super();
	}

	ngOnInit() {
		this.initRegistrationForm();

		this.route.queryParams.pipe(takeUntil(this.destroy)).subscribe((params) => {
			this.token = params['token'];
			this.username = params['username'];

			localStorage.setItem(environment.authTokenKey, this.token);
		});
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	initRegistrationForm() {
		this.form = this.formBuilder.group(
			{
				password: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(100)])],
				confirmPassword: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(100)])],
			},
			{
				validator: ConfirmPasswordValidator.MatchPassword,
			}
		);
	}

	submit() {
		const controls = this.form.controls;
		/** check form */
		if (this.form.invalid) {
			Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
			return;
		}

		this.spinnerService.showAppSpinner(); // Turns on app wide spinner

		//const email = controls.email.value;
		const passwordDto: PasswordChangeDto = {
			userNameOrEmail: this.username,
			newPassword: controls.password.value,
		};

		this.authService
			.changePassword(passwordDto, this.token)
			.pipe(takeUntil(this.destroy))
			.subscribe((responseMessage) => {
				if (responseMessage) {
					this.spinnerService.hideAppSpinner(); // Turns iff app wide spinner
					const message = responseMessage;
					this.coreService.toast({ message: message, type: StatusType.DANGER });
				} else {
					this.spinnerService.hideAppSpinner(); // Turns iff app wide spinner
					const message = this.translateService.instant('MODULE.AUTH.CHANGE.SUCCESS');
					this.coreService.toast({ message: message, type: StatusType.SUCCESS });
					this.router.navigateByUrl('/auth/login');
				}
			});
	}

	controlHasError(controlName: string, validationType: string): boolean {
		return FormHelper.controlHasError(this.form, controlName, validationType);
	}
}
